/**
 * EmptyState Component
 * 
 * Reusable empty state component with icon, message, and optional action.
 * Follows UI/UX guidelines for empty states.
 */

import React from 'react';
import { cn } from '@/lib/utils';
import { Button } from '../Button';

interface EmptyStateProps {
  icon: React.ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div 
      className={cn(
        'text-center py-12 bg-gray-50 rounded-lg border-2 border-dashed border-gray-300',
        className
      )}
    >
      <div className="mx-auto h-12 w-12 text-gray-400 flex items-center justify-center">
        {icon}
      </div>
      <h3 className="mt-4 text-sm font-medium text-gray-900">{title}</h3>
      {description && (
        <p className="mt-2 text-sm text-gray-500">{description}</p>
      )}
      {action && (
        <div className="mt-6">
          <Button size="sm" onClick={action.onClick}>
            {action.label}
          </Button>
        </div>
      )}
    </div>
  );
}

